<ng-container *transloco="let t;">
    
<div class="modal-header">
    <h4 class="modal-title" id="myModalLabel1">{{t('Bulk upload modal title (bulk upload) - Bulk Upload')}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="bulkUploadModalClose('close')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body p-0" tabindex="0" ngbAutofocus>
    <div>
 
        <!-- Step Uploading -->
        <div class="row m-0 ps-50 pe-50 bulk-upload-step" id="bulk-upload-step-upload"
             [class.active]="(documentsBulkUploadFacade.currentStep$ | async) === DocumentBulkUploadStepEnum.uploadCSV">
            <app-upload-files-init-step></app-upload-files-init-step>
            <div class="modal-footer">
                <button type="button" class="btn btn-outline-secondary" (click)="bulkUploadModalClose('close')"
                        rippleEffect>
                    {{ t('Cancel button (bulk upload) - Cancel`) }}
                </button>
                <button type="button" class="btn btn-outline-secondary"
                        [disabled]="documentsBulkUploadFacade.isSkipStepLoading$ | async"
                        (click)="documentsBulkUploadFacade.skip()" rippleEffect>
                    <span *ngIf="documentsBulkUploadFacade.isSkipStepLoading$ | async"
                          class="spinner-border spinner-border-sm me-1"></span>{{ t('Skip button (bulk upload) - Skip this step') }}
                </button>
                <button type="button" class="btn btn-success" (click)="documentsBulkUploadFacade.nextStep()"
                        rippleEffect
                        [disabled]="(documentsBulkUploadFacade.uploadId$ | async) === null || (documentsBulkUploadFacade.isFirstLineLoading$ | async) || (documentsBulkUploadFacade.isPotentialMappingLoading$ | async)">
                   <span *ngIf="(documentsBulkUploadFacade.isFirstLineLoading$ | async) || (documentsBulkUploadFacade.isPotentialMappingLoading$ | async)"
                         class="spinner-border spinner-border-sm me-1"></span>
                    {{ t('Next button (bulk upload) - Next') }}
                </button>
            </div>
        </div>
        <!-- / Step Uploading -->

        <!-- Step Mapping -->
        <div class="row m-0 p-0 bulk-upload-step" id="bulk-upload-step-mapping"
             [class.active]="(documentsBulkUploadFacade.currentStep$ | async) === DocumentBulkUploadStepEnum.mapColumn">
            <app-match-columns-step [first_line_titles]="documentsBulkUploadFacade.firstLineTitles$ | async"
                                    (first_line_titlesChange)="documentsBulkUploadFacade.updateFirstRowAndFetch($event)"
                                    [rowItems]="documentsBulkUploadFacade.firstRowData$ | async"
                                    [cardColumns]="documentsBulkUploadFacade.cardColumns$ | async"
                                    [loading]="(documentsBulkUploadFacade.isFirstLineLoading$ | async) || (documentsBulkUploadFacade.isPotentialMappingLoading$ | async)"
                                    (mappingChange)="documentsBulkUploadFacade.onMappingChange($event)">
            </app-match-columns-step>
            <div class="modal-footer">
                <button type="button" class="btn btn-outline-secondary" (click)="documentsBulkUploadFacade.prevStep()"
                        rippleEffect>
                    {{ t('Back button (bulk upload) - Back') }}
                </button>
                <button type="button" class="btn btn-success"
                        [disabled]="documentsBulkUploadFacade.isUpdateMappingRequestInProgress$ | async "
                        (click)=" this.documentsBulkUploadFacade.saveMapping()" rippleEffect>
                    <span *ngIf="documentsBulkUploadFacade.isUpdateMappingRequestInProgress$ | async"
                          class="spinner-border spinner-border-sm me-1"></span>   {{ t('Next button (bulk upload) - Next') }}
                </button>
            </div>
        </div>
        <!-- / Step Mapping -->

        <!-- Step Preview & Finalize -->
        <div class="row m-0 p-0 bulk-upload-step" id="bulk-upload-step-preview-finalize"
             [class.active]="(documentsBulkUploadFacade.currentStep$ | async) === DocumentBulkUploadStepEnum.preview">
            <app-upload-preview-step [previewData]="documentsBulkUploadFacade.previewData$ | async"
                                     [columns]="documentsBulkUploadFacade.previewColumns$ | async"
                                     [mergeOrganisations]="documentsBulkUploadFacade.mergeOrganisations$ | async"
                                     (mergeOrganisationsChange)="documentsBulkUploadFacade.onMergeOrganisationsChange($event)">
            </app-upload-preview-step>
            <div class="modal-footer">
                <button type="button" class="btn btn-outline-secondary" (click)="documentsBulkUploadFacade.prevStep()"
                        rippleEffect>
                    {{ t('Back button (bulk upload) - Back') }}
                </button>
                <button type="button" class="btn btn-success" rippleEffect
                        (click)="documentsBulkUploadFacade.importXLS()">
                    Import
                </button>
            </div>
        </div>
        <!-- / Step Preview & Finalize -->

        <!-- Step Uploading Files -->
        <div class="row m-0 ps-50 pe-50 bulk-upload-step d-flex" id="bulk-upload-step-upload"
             [formGroup]="uploadForm"
             [class.active]="(documentsBulkUploadFacade.currentStep$ | async) === DocumentBulkUploadStepEnum.uploadPDF">
            <app-upload-files class="d-flex"></app-upload-files>
            <app-ai-generate-activity [submitted] = "uploadModalSubmitted" (formDataChanged)="onActivityFormDataChanged($event)" (isValid)="onActivityFormDataValidityChanged($event)" ></app-ai-generate-activity>
            <div class="modal-footer">
                <button type="button" class="btn btn-outline-secondary" (click)="documentsBulkUploadFacade.prevStep()"
                        rippleEffect>
                    {{ t('Back button (bulk upload) - Back`) }}
                </button>
                <button type="button" class="btn btn-success"
                        (click)="onUploadNextButtonClick()"
                        rippleEffect
                        [disabled]="uploadForm.invalid">
                    {{t('Next button (bulk upload) - Next')}}
                </button>
            </div>
        </div>
        <!-- / Step Uploading Files -->

        <!-- Step Matching Files -->
        <div class="row m-0 p-0 bulk-upload-step" id="bulk-upload-step-file-match"
             [class.active]="(documentsBulkUploadFacade.currentStep$ | async) === DocumentBulkUploadStepEnum.matchFiles">
            <app-match-contract-cards-step></app-match-contract-cards-step>
            <div class="modal-footer">
                <button type="button" class="btn btn-outline-secondary" (click)="documentsBulkUploadFacade.prevStep()"
                        rippleEffect>
                    {{ t('Back button (bulk upload) - Back`) }}
                </button>
                <button type="button" class="btn btn-success" rippleEffect
                        (click)="importPDFClicked()">
                    {{ t('Import button (bulk upload) - Import') }}
                </button>
            </div>
        </div>
        <!-- / Step Matching Files -->

        <!-- Step Summary -->
        <div class="row m-0 p-0 bulk-upload-step" id="bulk-upload-step-file-summary"
             [class.active]="(documentsBulkUploadFacade.currentStep$ | async) === DocumentBulkUploadStepEnum.summary">
            <app-import-summary-step [imported]="documentsBulkUploadFacade.importedSummary$ | async"
                                     [unimported]="documentsBulkUploadFacade.unimportedSummary$ | async"></app-import-summary-step>
            <div class="modal-footer">
                <button type="button" class="btn btn-outline-secondary" (click)="documentsBulkUploadFacade.nextStep()"
                        rippleEffect>
                    {{ t('Back button (bulk upload) - Back') }}
                </button>
                <button type="button" class="btn btn-success" rippleEffect (click)="bulkUploadModalClose('close')">
                    {{ t('Close button (bulk upload) - Close') }}
                </button>
            </div>
        </div>
        <!-- / Step Summary -->
    </div>
</div>
</ng-container>